import { render, staticRenderFns } from "./CreateKeywordsInputBasic.vue?vue&type=template&id=6be647cc&scoped=true&"
import script from "./CreateKeywordsInputBasic.vue?vue&type=script&lang=js&"
export * from "./CreateKeywordsInputBasic.vue?vue&type=script&lang=js&"
import style0 from "./CreateKeywordsInputBasic.vue?vue&type=style&index=0&id=6be647cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6be647cc",
  null
  
)

export default component.exports